import React from 'react'

function ExclamationCircle ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width='20.002' height='20.002' viewBox='0 0 20.002 20.002'>
      <path d='M299,1650a10,10,0,1,0,10,10A10,10,0,0,0,299,1650Zm1.25,16.251h-2.5v-2.5h2.5Zm0-5h-2.5v-7.5h2.5Z' transform='translate(-289 -1649.999)' />
    </svg>
  )
}

ExclamationCircle.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default ExclamationCircle
